export const bpmnMenuDef = [
    {
        "name": "menu.bpmn_connector",
        "resource": "bpmn_connector",
        "icon": "fa fa-user-md",
        "url": "bpmn_connector",
        "auto_crud": true,
        "breadcrumb": "bpmn_connector",
        "check_permission": false,
        "showMenu": true
    },
    {
        "name": "menu.bpmn_process_object",
        "resource": "bpmn_process_object",
        "icon": "fa fa-user-md",
        "url": "bpmn_process_object",
        "auto_crud": true,
        "breadcrumb": "bpmn_process_object",
        "check_permission": false,
        "showMenu": true
    },
    {
        "name": "menu.bpmn_connector",
        "resource": "bpmn_connector_radiology",
        "icon": "fa fa-user-md",
        "url": "bpmn_connector_radiology",
        "auto_crud": true,
        "breadcrumb": "bpmn_connector_radiology",
        "check_permission": false,
        "showMenu": true
    },
    {
        "name": "menu.bpmn_process_object",
        "resource": "bpmn_process_object_radiology",
        "icon": "fa fa-user-md",
        "url": "bpmn_process_object_radiology",
        "auto_crud": true,
        "breadcrumb": "bpmn_process_object_radiology",
        "check_permission": false,
        "showMenu": true
    },
    {
        "name": "menu.bpmn_activity",
        "resource": "bpmn_activity",
        "icon": "fa fa-user-md",
        "url": "bpmn_activity",
        "auto_crud": true,
        "breadcrumb": "bpmn_activity",
        "check_permission": false,
        "showMenu": false
    },
    {
        "name": "menu.bpmn_event",
        "resource": "bpmn_event",
        "icon": "fa fa-user-md",
        "url": "bpmn_event",
        "auto_crud": true,
        "breadcrumb": "bpmn_event",
        "check_permission": false,
        "showMenu": false
    },
    {
        "name": "menu.bpmn_gateway",
        "resource": "bpmn_gateway",
        "icon": "fa fa-user-md",
        "url": "bpmn_gateway",
        "auto_crud": true,
        "breadcrumb": "bpmn_gateway",
        "check_permission": false,
        "showMenu": false
    },
    {
        "name": "menu.bpmn_expression",
        "resource": "bpmn_expression",
        "icon": "fa fa-user-md",
        "url": "bpmn_expression",
        "auto_crud": true,
        "breadcrumb": "bpmn_expression",
        "check_permission": false,
        "showMenu": false
    },
    {
        "name": "menu.pathology_process",
        "resource": "pathology_bpmn_process",
        "icon": "fa fa-user-md",
        "url": "pathology_bpmn_process",
        "auto_crud": true,
        "breadcrumb": "bpmn_expression",
        "check_permission": false,
        "showMenu": false
    },
    {
        "name": "menu.histopathology_process",
        "resource": "histopathology_bpmn_process",
        "icon": "fa fa-user-md",
        "url": "histopathology_bpmn_process",
        "auto_crud": true,
        "breadcrumb": "bpmn_expression",
        "check_permission": false,
        "showMenu": false
    },
    {
        "name": "menu.cytology_process",
        "resource": "cytology_bpmn_process",
        "icon": "fa fa-user-md",
        "url": "cytology_bpmn_process",
        "auto_crud": true,
        "breadcrumb": "bpmn_expression",
        "check_permission": false,
        "showMenu": false
    },
    {
        "name": "menu.radiology_process",
        "resource": "radiology_bpmn_process",
        "icon": "fa fa-user-md",
        "url": "radiology_bpmn_process",
        "auto_crud": true,
        "breadcrumb": "bpmn_expression",
        "check_permission": false,
        "showMenu": false
    }
]